import { useEffect, useRef } from 'react';
import { useLang } from '@src/context/LanguageContext';

/**
 * Runs `callback` only when the application language is switched while the component is mounted -
 * never on the first render. Use it to re-fetch data that carries backend generated TEXT (lookup
 * lists feeding selects/radios, status labels, messages...) so an already open page/form shows the
 * new language without a manual page refresh.
 *
 * The callback is kept in a ref, so it does not have to be memoized by the caller.
 */
export const useLanguageChange = (callback) => {
  const { language } = useLang();
  const callbackRef = useRef(callback);
  const previousLanguage = useRef(language);

  callbackRef.current = callback;

  useEffect(() => {
    if (previousLanguage.current === language) return;
    previousLanguage.current = language;
    callbackRef.current(language);
  }, [language]);
};

export default useLanguageChange;
